import { ConversationContext, FragmentTranslations, HostContext, mapObject, nameof } from "@buzzeasy/shared-frontend-utilities";
import { ReactElement, useContext } from "react";
import MainContainer from "../components/containers/MainContainer";
import Providers from "../components/providers/Providers";
import { FragmentGlobalStyle } from "../GlobalStyle";
import { translations } from "../translations";

import "@buzzeasy/shared-frontend-utilities/extensions";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface CallTranslatorFragmentProps {

}

// eslint-disable-next-line no-empty-pattern
export default function CallTranslatorFragment({ }: CallTranslatorFragmentProps): ReactElement {
  const hostContext = useContext(HostContext);
  const conversationContext = useContext(ConversationContext);

  if (!hostContext || !conversationContext)
    throw new Error("CallTranslatorFragment must be rendered within a HostContext and ConversationContext");

  return (
    <Providers conversationId={conversationContext.conversationId}>
      <FragmentGlobalStyle />
      <MainContainer
        showHeader={false}
        conversationId={conversationContext.conversationId}
      />
    </Providers>
  );
}

CallTranslatorFragment.displayName = nameof({ CallTranslatorFragment });
CallTranslatorFragment.translations = mapObject(translations, ([lang, val]) => [lang, val.translation]) as FragmentTranslations;
